import Service from "../../Services";

const Landing = {
    namespaced : true,
    state : {
        landing_data: null
    },
    mutations : {
        setLandingData(state, data) {
            state.landing_data = data;
        }
    },
    actions : {
        getBannerBg({ commit }) {
            return Service.LandingPageAPI.getBannerBg().then(res => {
               commit('setLandingData', res);
            });
        }
    }
};
export default Landing
